export var LOCAL_FILE_SAVE_CLASS_NAME = 'local-file-save';
export var LOCAL_EDIT_DOCUMENT_SAVED = 'local_edit_document_saved';